import React from 'react';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// import logo from './logo.svg';
// import { BrowserRouter as Router } from 'react-router-dom';
// import { ApolloProvider } from 'react-apollo';
// import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
// import SelectAg from './Sample';
// import { IntlProvider, addLocaleData } from 'react-intl';
// import { Provider as IntlContextProvider } from '../hooks/useFormatMessage';
// import SelectAgency from './components/SelectAgency';
// import Sample from './Sample';
// import Branches from './pages/branches';
// import Items from './pages/items';
// import Flyers from './pages/flyers';
// import { getRoutes } from './pages';
// import './App.css';
import configureStore from '../store/configureStore';

// import ApolloClient from 'apollo-boost';

// const apolloClient = new ApolloClient();
// to use redux-persist:
// https://github.com/rt2zz/redux-persist/issues/1008#issuecomment-474083851
// const { store, persistor } = configureStore();
const { store, persistor } = configureStore();

// const Persist: any = PersistGate;

function Redux(props: any) {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        {props.children}
      </PersistGate>
    </Provider>
  );
}

export default Redux;
